import React from "react";
import { Navigate, Routes, Route, useLocation } from "react-router-dom";

import Layout from "../pages/Layout";
import Login from "../components/auth/Login";
import Signup from "../components/auth/Signup";
import ResetPassword from "../components/auth/ResetPassword";
import ForgotPassword from "../components/auth/ForgotPassword";
import Profile from "../components/auth/Profile";
import Home from "../pages/Home";
import Factsheets from "../pages/Factsheets";
import Methods from "../pages/Methods";
import Initiatives from "../pages/Initiatives";
import Help from "../pages/Help";
import About from "../pages/About";
import ChangePassword from "../components/auth/ChangePassword";
import CmsPageComponent from "../components/CMS/CmsPagesComponent";
import DataVisualization from "../modules/DataVisualization";
import { useAuth } from "../context/AuthContext";
import InactivityHandler from "../context/inactivityHandler";

interface ProtectedRouteProps {
  children: React.ReactElement;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isLoggedIn } = useAuth();
  const location = useLocation();

  if (!isLoggedIn) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
};

const AppRoutes = () => {
  const { isLoggedIn, logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <div>
      {isLoggedIn && (
        <InactivityHandler
          onLogout={handleLogout}
        />
      )}
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />

          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/change-password"
            element={
              <ProtectedRoute>
                <ChangePassword />
              </ProtectedRoute>
            }
          />
          <Route
            path="/factsheets"
            element={
              <ProtectedRoute>
                <Factsheets />
              </ProtectedRoute>
            }
          />
          {/* <Route path="/factsheets" element={<Factsheets />} /> */}
          <Route path="/methods" element={<Methods />} />
          <Route path="/initiatives" element={<Initiatives />} />
          <Route path="/help" element={<Help />} />
          <Route path="/about" element={<About />} />

          {/*  CMS PAGES */}
          <Route path="/contact-us" element={<CmsPageComponent />} />
          <Route path="/terms-of-use" element={<CmsPageComponent />} />
          <Route path="/privacy-policy" element={<CmsPageComponent />} />
          <Route
            path="/data-visualization"
            element={
              <ProtectedRoute>
                <DataVisualization />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </div>
  );
};

export default AppRoutes;
